/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractControl } from '@angular/forms';
import { TranslationService } from '@nebula-shared/data-access';
export class ValidationHelper {
  private static translation: TranslationService;

  static setTranslationService(translation: TranslationService): void {
    ValidationHelper.translation = translation;
  }

  /**
   * Mensaje del primer error del control, traducido. Las claves son las que existen en la BD y los
   * parametros los que esas claves esperan (`{{maxLength}}`, `{{minLength}}`, `{{min}}`, `{{max}}`).
   */
  static getError(control: AbstractControl | null): string {
    if (!control || !(control.touched || control.dirty) || !control.errors) {
      return '';
    }

    const t = (key: string, params?: any): string =>
      ValidationHelper.translation?.translate(key, params);

    const messages: Record<string, (error?: any) => string> = {
      required: () => t('LAYOUT.VALIDATION.REQUIRED'),

      maxlength: (e) =>
        t('LAYOUT.VALIDATION.MAX_LENGTH', {
          maxLength: e.requiredLength,
        }),

      minlength: (e) =>
        t('LAYOUT.VALIDATION.MIN_LENGTH', {
          minLength: e.requiredLength,
        }),

      email: () => t('LAYOUT.VALIDATION.EMAIL'),

      min: (e) =>
        t('INVALID_FEEDBACK.MIN_VALUE', {
          min: e.min,
        }),

      max: (e) =>
        t('INVALID_FEEDBACK.MAX_VALUE', {
          max: e.max,
        }),

      pattern: () => t('ACCOUNTING.THIRD_PARTY.MESSAGE.ERROR.INVALID_FORMAT'),
    };

    const key = Object.keys(control.errors)[0];

    return messages[key]?.(control.errors[key]) ?? t('COMMON.VALIDATION.INVALID_VALUE');
  }
}
